import React, { useEffect, useState } from "react";
import { Loader } from "../../loader/Loader";
import { PaymentReleaseComponent } from "./PaymentRelease.component";
import { PaymentReleaseRequestAdminApi } from "./PaymentReleaseRequest.admin.api";
import {
  PaymentReleaseRequest,
  PaymentReleaseRequestsResponse,
  PaymentReleaseRequestStatus,
} from "./PaymentReleaseRequest.model";

interface PaymentReleaseRequestsForStatusProps {
  status: PaymentReleaseRequestStatus;
}

export function PaymentReleaseRequestsForStatus({
  status,
}: PaymentReleaseRequestsForStatusProps) {
  const [prrs, setPrrs] = useState<PaymentReleaseRequestsResponse>();

  useEffect(() => {
    setPrrs(undefined);
    PaymentReleaseRequestAdminApi.getAllPRRs(status).then((response) => {
      setPrrs(response);
    });
  }, [status]);

  if (!prrs) {
    return <Loader />;
  }

  return (
    <PaymentReleaseComponent
      paymentReleaseRequests={prrs}
      showReviewOptions={true}
      onPrrUpdate={function (index: number, prr: PaymentReleaseRequest) {
        if (prrs) {
          prrs.paymentReleaseRequests[index] = prr;
          setPrrs({ ...prrs });
        }

        return Promise.resolve();
      }}
    />
  );
}
